<template>
  <v-toolbar class="folder-toolbar"
             app
             fixed
             clipped-left
             color="white"
             v-if="!isEmpty(folder)"
  >
    <span class="folder-type-border" :style="{'border-left-color': folderBorderColor}">&nbsp;</span>
    <v-icon color="amber" class="mr-3" medium>mdi-folder-open</v-icon>
    <v-flex class="pa-2" xs4>
          <v-layout column>
            <v-flex>
              <strong class="grey--text text--darken-2 folder-id">{{ folder.process_number }}</strong>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="folder-type-name">
                   {{ folder.folder_type.name }}
                  </div>
                </template>

                {{ folder.folder_type.name }}
              </v-tooltip>
            </v-flex>
          </v-layout>
    </v-flex>

    <folder-secondary-action
      :showActions="showActions"
      @hideActions="showActions = false"
      @showActions="showActions = true"
      @searchDocument="$emit('searchDocument', $event)"
    />
    <v-spacer />
    <transaction-indicator :folder="folder"/>
    <v-spacer />
    <folder-primary-action
      :canBeSentFolder="canBeSentFolder"
      :canBeSentFolderToRevision="canBeSentFolderToRevision"
      :canBeReceiveFolder="canBeReceiveFolder"
      :canBeRequestFolder="canBeRequestFolder"
      :canBeAttached="canBeAttached"
    />
  </v-toolbar>
</template>

<script>
import colors from 'vuetify/es5/util/colors';
import { findIndex, first, isEmpty, isNull, truncate } from 'lodash';
import TransactionIndicator from '@/components/folder/show/toolbar/TransactionIndicator';
import FolderPrimaryAction from './action/FolderPrimaryAction';
import FolderSecondaryAction from './action/FolderSecondaryAction';
import Highlighter from 'vue-highlight-words'

export default {
  name: 'FolderToolbar',
  components: {
    FolderPrimaryAction,
    FolderSecondaryAction,
    TransactionIndicator,
    Highlighter
  },
  data() {
    return {
      isEmpty,
      showActions: true,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    folder() {
      return this.$store.getters.activeFolder;
    },
    folderViewMode() {
      return this.$store.getters.folderViewMode;
    },

    // Check
    folderHasPending() {
      return this.folderIsEmpty
          || this.folderHasPendingSignature
          || this.folderHasPendingRevision
          || this.folderIsRequestedOwnership;
    },
    folderIsEmpty() {
      return this.folder.documents.length === 0;
    },
    folderGettingStartedByYou() {
      return this.folder.transactions == null;
    },
    folderHasPendingRevision() {
      return findIndex(this.folder.documents, ['has_pending_revision', true]) !== -1;
    },
    folderHasPendingSignature() {
      return findIndex(this.folder.documents, ['has_pending_signature', true]) !== -1;
    },
    folderHasPendingReceipt() {
      return findIndex(this.folder.transactions, ['received', false]) !== -1;
    },
    folderIsRequestedOwnership() {
      return this.folder.ownership_requested;
    },
    folderSentToAdministrativeUnit() {
      if (this.folder.transactions.length > 0) {
        return first(this.folder.transactions).destination.id === this.user.administrative_unit.id;
      }
      return false;
    },
    folderSentToYou() {
      if (this.folder.transactions.length > 0) {
        if (isNull(first(this.folder.transactions).to_user)) {
          const destinationId = first(this.folder.transactions).destination.id;
          return destinationId === this.user.administrative_unit.id;
        }
        return first(this.folder.transactions).to_user.id === this.user.id;
      }
      return false;
    },
    folderTransactionForYou() {
      return this.folderSentToYou
          || this.folderSentToAdministrativeUnit;
    },
    folderOwnerIsYou() {
      return this.folder.current_owner.id === this.user.id;
    },
    folderArchived() {
      return this.$store.getters.folderStatusArchived.name === this.folder.folder_status.name;
    },
    lastFolderTransactionFromYou() {
      if (isEmpty(this.folder.transactions)) {
        return false;
      }
      return first(this.folder.transactions).from_user.id === this.user.id;
    },

    // Can be
    canBeSentFolder() {
      return !this.folderHasPending
          && this.folderOwnerIsYou
          && !this.folderHasPendingReceipt
          && !this.folderArchived;
    },
    canBeReceiveFolder() {
      return !this.folderGettingStartedByYou
        && !this.folderOwnerIsYou
        && this.folderHasPendingReceipt
        && this.folderTransactionForYou
        && !this.folderArchived;
    },
    canBeRequestFolder() {
      return !this.folderOwnerIsYou
        && !this.folderTransactionForYou
        && !this.folderArchived;
    },
    canBeSentFolderToRevision() {
      return !this.folderIsEmpty
          && this.folderHasPendingRevision
          && this.folderOwnerIsYou;
    },
    canBeAttached() {
      return this.folder.attached_folders.status !== 'attached'
          && !this.folderHasPendingReceipt
          && (this.folderOwnerIsYou
          || this.folderGettingStartedByYou);
    },
    // Border
    folderBorderColor() {
      if (this.folderHasPendingRevision) {
        return colors.amber.base;
      } else if (this.folderHasPendingSignature) {
        return colors.blue.base;
      }
      return colors.grey.base;
    },
  },
  methods: {
    updateViewMode(value) {
      this.$store.dispatch('FOLDER_VIEW_MODE', value);
    },
    truncate,
  },
};
</script>

<style scoped>

.folder-type-name{
  overflow: hidden;
  text-overflow: ellipsis;
  width: 35ch;
  white-space: nowrap;
}

  .folder-id {
    font-size: 12px;
  }
  .folder-type-border {
    position: absolute;
    height: 100%;
    left: 1px;
    border-radius: 3px 0 0 3px;
    border-left: 5px solid;
    transition: ease-in-out .15s;
  }
  .mdi-folder-open {
    -moz-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .role {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/FolderToolbar.vue